import React from "react";
import {
    Label,
    Wrapper,
} from "./styled.js";
import Select from 'react-select';


export const MCQ = ({ label, placeholder, required,
                             values, value = '', onChange, error,
                             disabled }) => {
    const options = values.map(value =>({ label: value, value }));
    const selectedOption = options[values.indexOf(value)];
    const handleOnChange = value =>{
        if (!onChange) {
            return;
        }

        onChange(value ? value.value: '');
    };
    return <Wrapper className="select-box">
        {label && <Label required={required}>{label}</Label>}
        <Select
            className={ error ? 'data-error': ''}
            classNamePrefix="react-select"
            placeholder={placeholder}
            required={required}
            options={options}
            isClearable={!required}
            value={selectedOption}
            onChange={handleOnChange}
            isDisabled={disabled}
        />
    </Wrapper>
};

export default MCQ;
